import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_OPH_MISS_REASON_GRAPH:
      return { ...state, ophMissReasons: action.payload };
    case ACTION_TYPES.FETCH_OPH_ATTAINMENT_RUN_CHART:
      return { ...state, runChartData: action.payload };
    default:
      return state;
  }
};
